// Mock data pour Nailed by Chloé

export const services = [
  {
    id: 1,
    category: 'Mains',
    categorySlug: 'mains',
    items: [
      { id: 'mains-vsp', name: 'Vernis Semi-Permanent', duration: '45min', price: '30€', category: 'mains', description: 'Pose de vernis longue tenue avec finition brillante ou mate.' },
      { id: 'mains-gainage', name: 'Gainage Ongle Naturel', duration: '1h30', price: '40€', category: 'mains', description: 'Renforcement de vos ongles naturels avec gel. Idéal pour les ongles fragiles.' },
      { id: 'mains-gelx', name: 'Extension Gel-X', duration: '2h', price: '40€', category: 'mains', description: 'Extension souple et naturelle avec capsules gel soft.' },
      { id: 'mains-capsules', name: 'Extension Capsules', duration: '3h', price: '50€', category: 'mains', description: 'Pose complète avec capsules et gel de construction.' },
      { id: 'mains-popit', name: 'Extension Popit', duration: '3h-3h30', price: '60€', category: 'mains', description: 'Technique avancée pour un résultat parfait et durable.' },
      { id: 'mains-remplissage-3-4', name: 'Remplissage 3-4 sem.', duration: '2h', price: '40€', category: 'mains', description: 'Entretien de vos extensions existantes.' },
      { id: 'mains-remplissage-4plus', name: 'Remplissage +4 sem.', duration: '2h30', price: '50€', category: 'mains', description: 'Remplissage avec reprise complète de la base.' }
    ]
  },
  {
    id: 2,
    category: 'Pieds',
    categorySlug: 'pieds',
    items: [
      { id: 'pieds-vsp', name: 'Vernis Semi-Permanent', duration: '45min', price: '25€', category: 'pieds', description: 'Pose de vernis longue tenue sur les orteils.' },
      { id: 'pieds-gainage', name: 'Gainage Ongle Naturel', duration: '1h', price: '35€', category: 'pieds', description: 'Renforcement gel pour des ongles de pieds impeccables.' }
    ]
  },
  {
    id: 3,
    category: 'Forfaits',
    categorySlug: 'forfaits',
    items: [
      { id: 'forfait-mains-pieds-semi', name: 'Mains + Pieds Semi', duration: '1h30', price: '50€', category: 'forfaits', description: 'Vernis semi-permanent mains et pieds. Économie de 5€ !' },
      { id: 'forfait-gainage-semi', name: 'Gainage Mains + Semi Pieds', duration: '2h30', price: '60€', category: 'forfaits', description: 'Gainage mains + vernis semi pieds. Pack complet !' },
      { id: 'forfait-gainage-complet', name: 'Gainage Mains + Pieds', duration: '3h', price: '70€', category: 'forfaits', description: 'Gainage complet mains et pieds. Le soin ultime !' }
    ]
  }
];

export const galleryImages = [
  {
    id: 1,
    url: 'https://customer-assets.emergentagent.com/job_1171b676-a9a3-4bf6-8119-9f35d1ed1e84/artifacts/uksjxg5w_597400022_122102548833164248_7629361759834453548_n.jpg',
    alt: 'Nail art élégant avec design or et noir brillant'
  },
  {
    id: 2,
    url: 'https://customer-assets.emergentagent.com/job_1171b676-a9a3-4bf6-8119-9f35d1ed1e84/artifacts/7uh6w7gr_600352846_122102553321164248_2470426783274028810_n.jpg',
    alt: 'Design nail art marbré avec touches dorées et finition brillante'
  },
  {
    id: 4,
    url: 'https://customer-assets.emergentagent.com/job_1171b676-a9a3-4bf6-8119-9f35d1ed1e84/artifacts/1i0b5o78_605735085_10164432642913826_6854470179170405128_n.jpg',
    alt: 'Ongles longs avec glitter doré et détails rouges festifs'
  },
  {
    id: 5,
    url: 'https://customer-assets.emergentagent.com/job_1171b676-a9a3-4bf6-8119-9f35d1ed1e84/artifacts/vuzvk9t7_607358180_10164432641758826_5128406307459079637_n.jpg',
    alt: 'Création nail art colorée rouge noir et rose avec motifs créatifs'
  }
];

export const businessInfo = {
  name: 'Nailed by Chloé',
  tagline: 'Prothésiste Ongulaire 974',
  location: 'Ravine des Cabris',
  region: 'La Réunion (974)',
  serviceType: 'Service à domicile',
  zones: ['Ravine des Cabris', 'Saint Pierre', 'Tampon'],
  hours: {
    weekdays: 'Lundi au Samedi',
    time: '8h - 18h'
  },
  services: [
    'Service à domicile',
    'Renforcement ongles naturels',
    'Extensions gels',
    'Ongles rongés bienvenus'
  ],
  logo: 'https://customer-assets.emergentagent.com/job_nailed-by-chloe/artifacts/dmo9kird_Capture%20d%E2%80%99%C3%A9cran%202025-12-30%20201100%20vect.png'
};

export const appointments = [];

export const addAppointment = (appointment) => {
  const newAppointment = {
    id: Date.now(),
    ...appointment,
    status: 'pending',
    createdAt: new Date().toISOString()
  };
  appointments.push(newAppointment);
  return newAppointment;
};

// ===== AVIS CLIENTS =====
// Mock data pour les avis - Sera remplacé par l'API Facebook Reviews
export const reviews = [];

// Fonction abstraite pour récupérer les avis
// Facebook Reviews integration ready - Cette fonction sera remplacée par l'API Facebook
export const fetchReviews = async () => {
  // TODO: Intégrer l'API Facebook Reviews
  // const response = await fetch('facebook_api_endpoint');
  // return await response.json();
  
  // Pour le moment, retourner les données mock
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(reviews);
    }, 300);
  });
};

// Calculer la note moyenne
export const getAverageRating = () => {
  if (reviews.length === 0) return 0;
  const sum = reviews.reduce((acc, review) => acc + review.rating, 0);
  return (sum / reviews.length).toFixed(1);
};

// Obtenir la distribution des notes
export const getRatingDistribution = () => {
  const distribution = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 };
  reviews.forEach(review => {
    distribution[review.rating]++;
  });
  return distribution;
};